module.exports = {
    tag: 'travelling',
    quality: 0.7,
    toughness: 1,
    strength: 1,
    speed: 0.4
};